import useCheckHostPermissions from '@website/hooks/useCheckHostPermissions';
import Link from 'next/link';
import { Button } from 'react-bootstrap';
import { AdminButton } from '../../admin/AdminButton';

type Props = {
  url: string;
  hostUrlSlug?: string;
};

export default function HostTripEditButtons({
  url,
  hostUrlSlug,
}: Props): JSX.Element {
  // Host Buttons
  const { isAuthorized: isHostAdmin } = useCheckHostPermissions(hostUrlSlug);

  return (
    <div className="d-flex justify-content-end py-3 container mx-auto">
      {isHostAdmin && (
        <>
          <Link
            href="/hosts/dashboard/[hostURL]"
            as={`/hosts/dashboard/${hostUrlSlug}`}
            legacyBehavior
          >
            <Button size="sm" className="me-1 mt-1">
              Host Dashboard
            </Button>
          </Link>
          <Link
            href="/trips/[tripUrl]/edit"
            as={`/trips/${url}/edit`}
            legacyBehavior
          >
            <Button className="me-1 mt-1" size="sm">
              Edit
            </Button>
          </Link>
        </>
      )}

      <AdminButton
        as="a"
        href={`/trips/${url}/reviews/seed`}
        size="sm"
        className="me-1 mt-1"
      >
        Seed Reviews
      </AdminButton>
    </div>
  );
}
